<div class="subject-preview h-100-p" style="max-height:500px; height:500px;" fxFlexAlign="row"
    fxLayoutAlign="stretch stretch">
    <div class="subject-list-preview" style="width:30%; max-width:40%;max-height: 400px;overflow-y: scroll;">
        <subject-list style="overflow-y: auto; height: 100%;" [subjects]="_subjects" [allowEdit]="allowEdit"
            [allowDelete]="allowDelete" [allowEditRelationship]="allowEditRelationship" [readOnly]="readOnly"
            (onEdit)="edit($event)" (onDelete)="delete($event)" (onSelect)="select($event)"
            (onChangeRelationship)="changeRelationship($event)" [noContentMessage]="noContentMessage"></subject-list>
    </div>
    <mat-divider *ngIf="_subjects && (_subjects.length > 0)" class="mat-divider" [vertical]="true" role="separator"
        aria-orientation="vertical"></mat-divider>
    <div *ngIf="_subjects && (_subjects.length > 0)" class="subject-card-preview p-24 h-100-p"
        style="max-height: 400px;overflow-y: scroll;">
        <div *ngIf="subject" class="w-100-p">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 pr-4">{{subject?.subjectType?.name}} -</div>
                <div class="h3">{{subject?.summary || subject?.reference}}</div>
            </div>
            <mat-divider class="px-16 my-16 w-100-p mat-divider mat-divider-horizontal" role="separator"
                aria-orientation="horizontal"></mat-divider>
            <subject-card [subject]='subject'></subject-card>
            <mat-divider *ngIf="showLinkedSubjects" class="px-16 my-16 w-100-p mat-divider mat-divider-horizontal" role="separator"
                aria-orientation="horizontal"></mat-divider>
            <div *ngIf="showLinkedSubjects" fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 pr-4">Linked Subjects</div>
            </div>
            <div *ngIf="showLinkedSubjects" fxLayout="row" fxLayoutAlign="start center">
                <linked-subjects-list #linkedSubjectsList [subject]='subject' style="width:100%; overflow-y: scroll;">
                </linked-subjects-list>
            </div>
        </div>
    </div>
    <div *ngIf="!subject" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <mat-icon class="s-120 mb-12 select-subject-icon" *fuseIfOnDom>subtitles
        </mat-icon>
        <span class="hint-text mat-h1 select-subject-text" *fuseIfOnDom>Select a subject</span>
    </div>
</div>